module.exports = __webpack_public_path__ + "img/2.7a7c2ce5.png";